<template>
  <el-dialog
    title="Generacion de nomina"
    :visible.sync="isVisible"
    @open="OnGenerateNominaOpen"
  >
    <el-form
      :model="NominaGenerationForm"
      ref="NominaGenerationForm"
      label-position="top"
      :rules="NominaGenerationFormRules"
    >
      <el-form-item label="Nomina: " prop="nominaName">
        <el-input
          v-model="NominaGenerationForm.nominaName"
          :disabled="true"
        ></el-input>
      </el-form-item>
      <el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="Mes" prop="NominaMonth">
              <el-date-picker
                v-model="NominaGenerationForm.NominaMonth"
                type="month"
                format="MMM-yyyy"
                placeholder="Seleccione el Mes"
                @change="OnMonthChange"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Tipo de Nomina: " prop="NominaType">
              <el-radio-group
                v-model="NominaGenerationForm.NominaType"
                @change="OnNominaTypeChange"
              >
                <el-radio :label="1">1ra Quincena</el-radio>
                <el-radio :label="2">2da Quincena</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-col :span="10">
          <el-form-item
            label="Empresa a la que pertenece"
            prop="pertainingCompany"
          >
            <el-select
              v-model="NominaGenerationForm.pertainingCompany"
              placeholder="Seleccione empresa"
              filterable
            >
              <el-option label="Tennos Business" value="TB"></el-option>
              <el-option label="Rabbey Technology" value="RB"></el-option>
              <el-option label="MagyTrack" value="MTR"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <!--
      <el-form-item
        v-if="NominaGenerationForm.NominaType === 15"
        label="Quincena: "
        prop="QuincenaType"
      >
        <el-radio-group v-model="NominaGenerationForm.QuincenaType">
          <el-radio :label="15">Primera Quincena</el-radio>
          <el-radio :label="30">Segunda Quincena</el-radio>
        </el-radio-group>
      </el-form-item>
      -->
      <el-row>
        <el-col :span="10">
          <el-form-item label="Fecha desde:" prop="fromDate">
            <el-date-picker
              v-model="NominaGenerationForm.fromDate"
              type="date"
              placeholder="Selecciona un dia"
              :picker-options="frompickerOptions"
              @change="onFromDateChange"
              :disabled="true"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="Fecha Hasta:" prop="toDate">
            <el-date-picker
              v-model="NominaGenerationForm.toDate"
              type="date"
              placeholder="Selecciona un dia"
              :picker-options="toPickerOptions"
              @change="onToDateChange"
              :disabled="true"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer">
      <el-button @click="onCancel" :disabled="fetchinNominaDetail">
        Cancelar
      </el-button>
      <el-button
        @click="GenerateNomina"
        v-loading="fetchinNominaDetail"
        :disabled="fetchinNominaDetail"
      >
        Generar
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "FormGenerateNomina",
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    companySeleted: {
      type: String,
      default: "TB"
    }
  },

  data() {
    return {
      NominaGenerationForm: {
        NominaType: 1,
        pertainingCompany: "",
        QuincenaType: "",
        NominaMonth: new Date(),
        fromDate: "",
        toDate: "",
        nominaTypeDesc: {
          1: "1ra Quincena",
          2: "2da Quincena"
        },
        nominaName: "Nomina del "
      },
      fetchinNominaDetail: false,
      NominaGenerationFormRules: {
        NominaType: [
          {
            required: true,
            message: "Por favor seleccione la quincena",
            trigger: "blur"
          }
        ],
        NominaMonth: [
          {
            required: true,
            message: "Por favor seleccione el mes",
            trigger: "blur"
          }
        ],
        pertainingCompany: [
          {
            required: true,
            message: "Por favor seleccione la empresa",
            trigger: "blur"
          }
        ]
      },
      monthNames: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Deciembre"
      ],
      frompickerOptions: {
        disabledDate(time) {
          /*
          let dateCompared;
          if (this.NominaGenerationForm.NominaType === 30) {
            dateCompared = time.getDate() !== 1
          }
          else if (this.NominaGenerationForm.NominaType === 15 && this.NominaGenerationForm.QuincenaType === 15) {
            dateCompared = time.getDate() !== 1
          }
          else {
            dateCompared = time.getDate() !== 15
          }
          */
          return time.getDate() !== 1 && time.getDate() !== 16;
        }
      },
      toPickerOptions: {
        disabledDate(time) {
          //const actualDate = new Date()
          /*
          let dateCompared;
          if (this.NominaGenerationForm.NominaType === 30) {
            dateCompared = time.getMonth() !== (2-1) ? time.getDate() !== 30 :  time.getDate() !== 28
          }
          else if (this.NominaGenerationForm.NominaType === 15 && this.NominaGenerationForm.QuincenaType === 15) {
            dateCompared = time.getDate() !== 15
          }
          else {
            dateCompared = time.getMonth() !== (2-1) ? time.getDate() !== 30 :  time.getDate() !== 28
          }
          */
          return (
            time.getDate() !== 16 &&
            (time.getMonth() !== 2 - 1
              ? time.getDate() !== 30
              : time.getDate() !== 28)
          );
        }
      }
    };
  },
  computed: {
    dialogVisible() {
      return this.isVisible;
    }
  },
  methods: {
    GenerateNomina() {
      this.$refs.NominaGenerationForm.validate((valid) => {
        if (valid) {
          this.fetchinNominaDetail = true;
          this.$http
            .get("/api/Payroll/GenerateNomina", {
              params: {
                companyID: this.NominaGenerationForm.pertainingCompany,
                User: this.currentUser.UserID,
                NominaName: this.NominaGenerationForm.nominaName,
                fromDate: this.NominaGenerationForm.fromDate,
                toDate: this.NominaGenerationForm.toDate,
                Biweekly: this.NominaGenerationForm.NominaType,
                isNew: true
              }
            })
            .then((resp) => {
              resp;

              //this.NominaData = resp.data
            })
            .catch((err) => {
              console.error(err);
            })
            .finally(() => {
              this.$refs.NominaGenerationForm.resetFields();
              this.$emit("NominaGeneration");
              this.fetchinNominaDetail = false;
            });
        } else {
          return false;
        }
      });
    },
    resetNominaGenerationForm() {
      this.$refs.NominaGenerationForm.resetFields();
    },
    onCancel() {
      this.$refs.NominaGenerationForm.resetFields();
      this.dialogVisible = false;
      this.$emit("onCloseNominaGeneration");
    },
    onFromDateChange(value) {
      this.NominaGenerationForm.nominaName = "Nomina del ";
      let val = new Date(value);
      this.NominaGenerationForm.nominaName +=
        val.getDate() +
        " de " +
        this.monthNames[val.getMonth()] +
        " del " +
        val.getFullYear();

      if (val.getDate() === 1) {
        val.setDate(val.getDate() + 14);
      } else {
        if (val.getMonth() === 2 - 1) {
          if (this.esBisiesto(val.getFullYear())) {
            val.setDate(val.getDate() + 14);
          } else {
            val.setDate(val.getDate() + 13);
          }
        } else {
          val.setDate(val.getDate() + 14);
        }
      }

      /*
      if (this.NominaGenerationForm.NominaType === 30) {
        if (val.getMonth() === 2 - 1) {
          if (this.esBisiesto(val.getFullYear())) {
            val.setDate(val.getDate() + 28);
          } else {
            val.setDate(val.getDate() + 27);
          }
        } else {
          val.setDate(val.getDate() + 29);
        }
      } else {
        if (val.getDate() === 1) {
          val.setDate(val.getDate() + 14);
        } else {
          if (val.getMonth() === 2 - 1) {
            if (this.esBisiesto(val.getFullYear())) {
              val.setDate(val.getDate() + 14);
            } else {
              val.setDate(val.getDate() + 13);
            }
          } else {
            val.setDate(val.getDate() + 14);
          }
        }
      }
      */
      this.NominaGenerationForm.toDate = val;
    },
    onToDateChange(value) {
      let val = new Date(value);
      let sufix;
      sufix = [];
      sufix = " al " + val.getDate() + " de " + this.monthNames[val.getMonth()];
      this.NominaGenerationForm.nominaName += sufix;
    },
    esBisiesto(year) {
      return year % 400 === 0
        ? true
        : year % 100 === 0
        ? false
        : year % 4 === 0;
    },
    OnNominaTypeChange(val) {
      this.NominaGenerationForm.nominaName = "Nomina del ";
      let month = new Date(this.NominaGenerationForm.NominaMonth);

      let date = new Date(month);
      let date2 = new Date(month);

      console.log(
        "monthdate: ",
        month,
        "month: ",
        month.getMonth(),
        "day: ",
        month.getDate()
      );
      console.log(
        "date: ",
        date,
        "datemonth: ",
        date.getMonth(),
        "dateday: ",
        date.getDate()
      );

      if (val === 1) {
        date = new Date(`${date.getFullYear()}-${date.getMonth() + 1}`);
        console.log(
          "2date: ",
          date,
          "datemonth: ",
          date.getMonth(),
          "dateday: ",
          date.getDate()
        );
        month.getMonth() > 8 && date.setDate(date.getDate() + 1);

        date2.setDate(date.getDate() + 14);
      } else {
        date = new Date(`${date.getFullYear()}-${date.getMonth() + 1}-16`);
        month.getMonth() > 8 && date.setDate(date.getDate() + 1);
        if (date.getMonth() === 2 - 1) {
          // if (this.esBisiesto(date.getFullYear())) {
          //   date2.setDate(date.getDate() + 13);
          // } else {
          //   date2.setDate(date.getDate() + 12);
          // }
          date2.setDate(
            new Date(date2.getFullYear(), date2.getMonth() + 1, 0).getDate()
          );
        } else {
          // date2.setDate(date.getDate() + 14);
          date2.setDate(
            new Date(date2.getFullYear(), date2.getMonth() + 1, 0).getDate()
          );
        }
      }
      this.NominaGenerationForm.fromDate = date;
      this.NominaGenerationForm.toDate = date2;
      this.NominaGenerationForm.nominaName = `Nomina del ${date.getDate()} al ${date2.getDate()} de ${
        this.monthNames[date.getMonth()]
      } del ${date.getFullYear()}`;
    },
    OnMonthChange() {
      this.OnNominaTypeChange(this.NominaGenerationForm.NominaType);
    },
    OnGenerateNominaOpen() {
      this.OnMonthChange();
    }
  },
  watch: {
    /*
    NominaGenerationForm(val) {
      console.log("NominaType: ", val);
    }
    */
  }
};
</script>

<style></style>
